import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Card, Image } from "react-bootstrap";

import SignUp from "../../components/auth/SignUp";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchWhitelabel } from "../../redux/slices/whitelabel";
import { useWhitelabel } from "../../contexts/WhitelabelContext";
import Loader from "../../components/spinners/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { retrieveDemoContactByToken } from "../../redux/slices/demoContacts";

const SignUpPage = () => {
  const currentUrl = window.location.hostname;
  const dispatch = useDispatch();

  const { token } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { whitelabelUrl, faviconUrl, backgroundColor, fontColor } =
    useWhitelabel();

  useEffect(() => {
    if (window.location.origin === "https://platform.clicksims.com") {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-4KL9TBHM9P";
      document.head.appendChild(script);

      const inlineScript = document.createElement("script");
      inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-4KL9TBHM9P');
    `;
      document.head.appendChild(inlineScript);

      return () => {
        document.head.removeChild(script);
        document.head.removeChild(inlineScript);
      };
    }
  }, []);

  useEffect(() => {
    const fetchDemoContactByToken = async () => {
      await dispatch(retrieveDemoContactByToken({ token }))
        .then(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        })
        .catch((error) => {
          navigate("/auth/invalid-token");
        });
    };

    if (token) {
      fetchDemoContactByToken();
    }
  }, [token]);

  if (isLoading) {
    return (
      <React.Fragment>
        <Helmet title="Sign Up">
          <link rel="icon" href={faviconUrl} />
        </Helmet>

        <Card>
          <Card.Body>
            <Loader />
          </Card.Body>
        </Card>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Helmet title="Sign Up">
        <link rel="icon" href={faviconUrl} />
      </Helmet>

      <Card>
        <Card.Body>
          <div className="m-sm-4" id="SignUpCard">
            <div className="text-center">
              <Image
                src={whitelabelUrl}
                alt=""
                className="img-fluid"
                width="150"
                height="150"
              />
            </div>
            <SignUp />
          </div>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default SignUpPage;
